export default __webpack_public_path__ + "static/media/sleepy.ecb94965.mp3";